import { newEntity } from 'entities-next/common'

import { Corporate, CorporateStatus } from './corporate.types'

export function newCorporate(): Corporate {
  return {
    ...newEntity(),
    enabledFeatures: [],
    name: 'New Corporate',
    status: CorporateStatus.inactive,
    demo: false,
    seatsLimit: 999,
  }
}
